/*
 * We return the lowest one by default.
 */
export const getBackgroundColor = (colorMap: [number, string][]) => (temp: number) => {
  const rangeItem = colorMap.find(([range, _]) => {
    if (temp < range) {
      return true;
    }
    return false;
  });
  if (rangeItem) {
    return rangeItem[1];
  }
  return colorMap[0][1];
};
